import { ActionTree } from 'vuex';
import {
  firestorePdrTeam, collection, where, query, getDocs, orderBy,
} from '@/firebase';
import { RootState } from '../types';
import { NewsFeedState } from './types';

const tmp = 0;

const actions: ActionTree<NewsFeedState, RootState> = {
  async fetchNewsFeed({ commit }) {
    const newsRef = collection(firestorePdrTeam, 'news');
    const q = query(
      newsRef,
      where('visible', '==', true),
      orderBy('createdAtUnix', 'desc'),
    );
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      // console.log(doc.id, ' => ', doc.data());
      commit('addNewsFeedEntry', {
        id: doc.id,
        data: doc.data(),
      });
    });
  },
  displayNewsFeedItem({ commit }, newsFeedItemId: string) {
    commit('setNewsFeedItemToDisplay', newsFeedItemId);
    commit('setDisplayNewsItem', true);
  },
};

export {
  actions,
  tmp,
};
